import { SxProps } from '@mui/material';

export const styles: Record<string, SxProps> = {
  button: {
    borderRadius: '14px',
    padding: '10px 16px',
  },
};
